export interface ValidationViolation {
  field?: string;
  checkingType: CheckingTypeEnum;
  message?: string;
  code?: string;
  value?: string;
}

export const CheckingTypeEnum = {
  SHORT_ACCOUNT: 'SHORT_ACCOUNT',
  SHORT_SELL: 'SHORT_SELL',
  PORTFOLIO_WARNING_MESSAGE: 'PORTFOLIO_WARNING_MESSAGE',
  ACCOUNT_BALANCE_BLOCKED: 'ACCOUNT_BALANCE_BLOCKED',
  ACCOUNT_BLOCKED: 'ACCOUNT_BLOCKED',
  COUNTRY_TRADING_REGULATION_FOR_RESIDENT: 'COUNTRY_TRADING_REGULATION_FOR_RESIDENT',
  COUNTRY_TRADING_REGULATION_FOR_SECURITY: 'COUNTRY_TRADING_REGULATION_FOR_SECURITY',
  LIMIT_DATE: 'LIMIT_DATE',
  LIMIT_PRICE: 'LIMIT_PRICE',
  NUMBER_DECIMAL: 'NUMBER_DECIMAL',
  SECURITY_BLOCKED: 'SECURITY_BLOCKED',
  GENERIC_EXISTING_ORDER_ERROR: 'GENERIC_EXISTING_ORDER_ERROR',
  SIMILAR_ISIN: 'SIMILAR_ISIN',
  GENERIC_ERROR: 'GENERIC_ERROR',
  LIMIT_EXCEED: 'LIMIT_EXCEED'
} as const;

export type InvestmentOrderCheckingTypeEnum = typeof CheckingTypeEnum;
export type CheckingTypeEnum = InvestmentOrderCheckingTypeEnum[keyof InvestmentOrderCheckingTypeEnum];
